module.exports = __webpack_public_path__ + "img/cloud-rain-lightning-moon.15854106.svg";